<template>
  <div id="app">
<!--    <img src="./assets/logo.png">-->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    let path=this.$route.path;
    if(this._isMobile()){
      // console.log(path)
      //移动端
      // if(!path.includes("form_pc")) {
      //   this.$router.replace('/form_pc')
      // }
      if(!path.includes("index_pc") && !path.includes("mob") && !path.includes("news")) {
        console.log(path)
        this.$router.replace('/index_pc')
      }
    }else{
      //web
      // console.log(this.$route.path);
      if(path.includes("supplierBorad_mob")){
        this.$router.replace('/supplierBorad_web')
      }else if(path.includes("borad_mob")){
        this.$router.replace('/borad_web')
      }else if(!path.includes("web")){
        this.$router.replace('/index_web')
      }
    }
  },
  methods:{
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    }
  }
}
</script>

<style>

@font-face {
  font-family: 'QingShanALiFont';
  src: url('./assets/AlibabaPuHuiTi-3-55-Regular.woff2') format('woff2'),
        url('./assets/AlibabaPuHuiTi-3-55-Regular.woff') format('woff'),
       url('./assets/AlibabaPuHuiTi-3-55-Regular.ttf') format('ttf');  
  font-weight: normal;
  font-style: normal;
}

#app {
  font-family: 'QingShanALiFont', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue